<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]">

      <header class="widget-header">
        <h2 class="widget-title">{{ title }}</h2>
        <h3 class="widget-title-period">
          <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
        </h3>

        <div class="widget-actions-container">
          <!--<div><form-toggle label="" v-model="is_ttc" label-true="TTC" label-false="HT"></form-toggle></div>-->
          <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
        </div>

        <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
          <span>Filtrer par date</span>
          <div class="date-filters">
            <form-datetime label="du" v-model="dateFilter.start_at" :hide-time="true" time="00:00:00"></form-datetime>
            <form-datetime label="au" v-model="dateFilter.end_at" :hide-time="true" time="23:59:59"></form-datetime>
          </div>
        </div>
      </header>

      <div class="widget-preloader">
        <div class="pre-loader">
          <div class="box1"></div>
          <div class="box2"></div>
          <div class="box3"></div>
          <div class="box4"></div>
          <div class="box5"></div>
        </div>
      </div>

      <div class="widget-content" v-if="stats.dataset">
        <div class="widget-content-datas">
          <div class="data-labels">

            <div class="data-label">
              <strong>{{ totalsms }}</strong>
              <span class="compare-to-previous">
                          <compare :previous="totalsms_compare" :current="totalsms"></compare>
                        </span>
              <span class="legend">SMS Envoyés</span>
            </div>

            <div class="data-label">
              <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ costsms|formatNumber }}</strong>
              <span class="legend">Coûts SMS</span>
            </div>

            <div class="data-label">
              <strong>{{ totalemail }}</strong>
              <span class="compare-to-previous">
                          <compare :previous="totalemail_compare" :current="totalemail"></compare>
                        </span>
              <span class="legend">EMAIL Envoyés</span>
            </div>

            <div class="data-label">
              <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ costemail|formatNumber }}</strong>
              <span class="legend">Coûts Email</span>
            </div>

          </div>

        </div>

        <div class="widget-chart" v-bind:class="{'active':stats.labels.length}" @click="setChartToFull">
          <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
        </div>
      </div>
    </div>
</template>
<script>

    import CampaignService from './CampaignService.js';
    import Chart from '../../../components/chart/Line.vue'

    export default {
        name: 'Widget',
        components: {
            'chart' : Chart
        },
        props: ['title','period','className','branch'],
        data () {
            return {
                periods: [
                  {id: 'last_7days', label: '7 derniers jours'},
                  {id: 'current_month', label: 'Ce mois'},
                  {id: 'last_month', label: 'Le mois dernier'},
                  {id: 'since_1_month', label: '30 derniers jours'},
                  {id: 'since_3_months', label: '90 derniers jours'},
                  {id: 'current_year', label: 'Cette année'},
                  {id: 'last_year', label: 'Depuis 12 mois'},
                  {id: 'all', label: 'Tout'},
                  {id: 'custom', label: 'Personnalisé'},
                ],
                stats: {
                    dataset: null,
                    labels: null
                },
                count: null,
                total: null,
                currency: null,
                is_ttc: true,
                options: {
                    layout: {
                        padding: {
                            left: 20,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    scales: {
                        xAxes: [ {
                            categoryPercentage: 0.9,
                            barPercentage: 0.9,
                            stacked: true,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: false,
                                display: false,
                                color: "#cccccc"
                            }
                        }],
                        yAxes: [ {
                            stacked: true,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: true,
                                display: true,
                                color: "#cccccc",
                                borderDashOffset: 1,
                                borderDash: [2,2]
                            }
                        }]
                    }
                }
            }
        },
        mounted: function(){

          this.currency = this.$store.state.scope.currency_id
          this.is_ttc = this.$store.state.scope.is_ttc
          this.period = this.period ? this.period : this.periods[0].id

          if(this.period == 'custom') {
            this.showAdvancedFilterVue = true
          }else{
            this.showAdvancedFilterVue = false;
          }

          this.filterByPeriod(this.period);

        },
        methods: {
          setChartToFull: function()
          {
            this.options.layout.padding = {
              left: -10,
              right: 0,
              top: 0,
              bottom: -10
            };
            this.options.scales.xAxes[0].ticks.display = true;
            this.options.scales.xAxes[0].gridLines.display = true;
            this.options.scales.yAxes[0].ticks.display = true;

          },
          filterByPeriod: function(period)
          {

            if(period == 'custom') {
              this.showAdvancedFilterVue = true
            }else{
              this.showAdvancedFilterVue = false;
            }

            if(period != 'custom') {

              this.loaded = false;
              this.period = period;

              CampaignService.getStats( this.period ).then((response) => {
                this.stats.dataset = response.data.result.stats.dataset
                this.stats.labels = response.data.result.stats.labels

                this.totalsms = response.data.result.totalsms
                this.totalemail = response.data.result.totalemail

                this.totalsms_compare = response.data.result.totalsms_compare
                this.totalemail_compare = response.data.result.totalemail_compare

                this.costsms = response.data.result.costsms
                this.costemail = response.data.result.costemail

                this.loaded = true;
              }).catch((response) => {
                console.log("error", response);
                this.loaded = true;
              })

            }
          },
          filterByPeriodAndByDate: function(period, dateFilter)
          {
            this.loaded = false;

            this.period = period
            this.date = JSON.stringify(dateFilter);

            CampaignService.getStats( this.period, this.date ).then((response) => {
              this.stats.dataset = response.data.result.stats.dataset
              this.stats.labels = response.data.result.stats.labels

              this.totalsms = response.data.result.totalsms
              this.totalemail = response.data.result.totalemail

              this.totalsms_compare = response.data.result.totalsms_compare
              this.totalemail_compare = response.data.result.totalemail_compare

              this.costsms = response.data.result.costsms
              this.costemail = response.data.result.costemail

              this.loaded = true;
            }).catch((response) => {
              console.log("error", response);
              this.loaded = true;
            })
          }
        },
        watch: {
          'dateFilter.start_at'(newVal, oldVal) {
            if(newVal != '' && this.dateFilter.end_at != ''){
              this.filterByPeriodAndByDate(this.period, this.dateFilter);
            }
          },
          'dateFilter.end_at'(newVal, oldVal) {
            if(newVal != '' && this.dateFilter.start_at != ''){
              this.filterByPeriodAndByDate(this.period, this.dateFilter);
            }
          }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/campaign/campaign/CampaignByMonthWidget.vue